import React from 'react'
import Select from 'react-select'



export const Filter = () => {

    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    return (
        <>
            <div className="row  pt-2">
                <div className='col-12 col-lg-4 pt-3'>

                    <h5 className='fw-bold'>
                    Dashboard 
                    </h5>
                </div>

                <div className='col-12 col-lg-8 border py-2 bg-white shadow '>
                    <div className='row'>
                        <div className="col-12 col-md-6 col-lg-4">
                            {/* <span>State</span> */}
                            <Select
                                placeholder="State"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        //   borderColor: state.isFocused ? 'grey' : 'red',
                                        borderColor: state.isFocused ? 'transparent' : 'transparent',
                                        borderBottomColor: 'black',
                                        boxShadow: 'none',
                                        // background:"black",
                                        // color:"white"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        color: 'black'
                                    })
                                }} options={options} />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            {/* <span>Regional Office</span> */}
                            <Select
                                placeholder="Regional Office"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        //   borderColor: state.isFocused ? 'grey' : 'red',
                                        borderColor: state.isFocused ? 'transparent' : 'transparent',
                                        borderBottomColor: 'black',
                                        boxShadow: 'none',
                                        // background:"black",
                                        // color:"white"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        color: 'black'
                                    })
                                }} options={options} />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            {/* <span>Field Station</span> */}
                            <Select
                                placeholder="Field Station"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        //   borderColor: state.isFocused ? 'grey' : 'red',
                                        borderColor: state.isFocused ? 'transparent' : 'transparent',
                                        borderBottomColor: 'black',
                                        boxShadow: 'none',
                                        // background:"black",
                                        // color:"white"
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        color: 'black'
                                    })
                                }} options={options} />
                        </div>
                    </div>
                </div>





            </div>
        </>
    )
}